var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.875 6.70312H14.9531V6.35938C14.9531 4.17656 13.1828 2.40625 11 2.40625C8.81719 2.40625 7.04688 4.17656 7.04688 6.35938V6.70312H4.125C3.74473 6.70312 3.4375 7.01035 3.4375 7.39062V18.9062C3.4375 19.2865 3.74473 19.5938 4.125 19.5938H17.875C18.2553 19.5938 18.5625 19.2865 18.5625 18.9062V7.39062C18.5625 7.01035 18.2553 6.70312 17.875 6.70312ZM13.4062 6.70312H8.59375V6.35938C8.59375 5.02949 9.67012 3.95312 11 3.95312C12.3299 3.95312 13.4062 5.02949 13.4062 6.35938V6.70312Z",
    fill: "#1E2A7B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty-cart.4054c0337ab7376ee7e62e1a8afc3303.svg";
export { ForwardRef as ReactComponent };